<template>
  <div v-if="visible" class="draw-signature-modal" @click="handleCancel">
    <div class="modal-content" @click.stop>
      <div class="canvas-wrapper">
        <canvas ref="canvas"></canvas>
      </div>
      <div class="button-group">
        <button class="btn-cancel" @click="handleCancel">取消</button>
        <button class="btn-confirm" :class="{ 'btn-disabled': !hasDrawn }" @click="handleConfirm">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'

export default {
  name: 'DrawSignatureModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      signaturePad: null,
      hasDrawn: false
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initCanvas()
        })
      } else {
        this.destroy()
      }
    }
  },
  methods: {
    initCanvas () {
      const canvas = this.$refs.canvas
      if (!canvas) return

      // 设置Canvas尺寸
      const canvasSize = this.calculateCanvasSize()
      canvas.width = canvasSize[0]
      canvas.height = canvasSize[1]

      // 初始化SignaturePad
      this.signaturePad = new SignaturePad(canvas, {
        backgroundColor: '#FFFFFF',
        minDistance: 2,
        penColor: '#000000'
      })

      // 监听开始绘制事件
      this.signaturePad.addEventListener('beginStroke', () => {
        this.hasDrawn = true
      }, { once: false })
    },
    calculateCanvasSize () {
      const canvasSize = [742, 442]
      const ratioX = canvasSize[0] / window.innerWidth
      const ratioY = canvasSize[1] / window.innerHeight

      const ratio = Math.max(ratioX, ratioY)
      if (ratio > 1) {
        canvasSize[0] /= ratio
        canvasSize[1] /= ratio
      }

      return canvasSize
    },
    handleCancel () {
      this.$emit('cancel')
      this.hasDrawn = false
    },
    handleConfirm () {
      if (!this.hasDrawn || !this.signaturePad || this.signaturePad.isEmpty()) {
        return
      }

      const dataURL = this.signaturePad.toDataURL('image/png')
      this.$emit('confirm', dataURL)
      this.hasDrawn = false
    },
    destroy () {
      if (this.signaturePad) {
        this.signaturePad.off()
        this.signaturePad = null
      }
    }
  },
  beforeDestroy () {
    this.destroy()
  }
}
</script>

<style lang="stylus" scoped>
.draw-signature-modal
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  z-index 9999
  background-color rgba(0, 0, 0, 0.7)
  display flex
  justify-content center
  align-items center

.modal-content
  background-color #fff
  border-radius 8px
  padding 10px
  max-width 90%
  max-height 90%
  display flex
  flex-direction column
  overflow hidden

.canvas-wrapper
  flex 1
  display flex
  justify-content center
  align-items center
  margin-bottom 10px

.button-group
  display flex
  justify-content space-around
  gap 10px
  width 100%

.btn-cancel,
.btn-confirm
  flex 1
  padding 1px 20px
  font-size 16px
  border-radius 6px
  border none
  cursor pointer
  transition all 0.3s
  height 30px

.btn-cancel
  background-color #fff
  color #333
  border 1px solid #ddd

  &:active
    background-color #f5f5f5

.btn-confirm
  background-color #f8b61c
  color #fff

  &:active
    background-color #e0a519

  &.btn-disabled
    opacity 0.5
    cursor not-allowed
    background-color #fcd682
</style>




// WEBPACK FOOTER //
// DrawSignatureModal.vue?af0eb55c